// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2q-1";
export var rateTableServiceLevelDropdown = "_2q-3";
export var rateTableTypeDropdown = "_2q-0";
export var rateTableValueModeDropdown = "_2q-2";